import(/* webpackMode: "eager" */ "/vercel/path0/src/app/checkout/page.tsx");
